import { favouritesUpdate } from './favourites-update.js';

export function favouritesEditModal() {
    var archiveBtn = document.querySelector('.js-archive-btn');
    var confirmBtns = document.querySelector('.js-delete-wishlist-confirm');
    var cancelBtn = document.querySelector('.js-cancel-delete');
    var deleteBtn = document.querySelector('.js-confirm-delete');
    var updateBtn = document.querySelector('.js-update-button');
    var addFriendBtn = document.querySelector('.js-add-friend-btn');
    var addFriendBlock = document.querySelector('.js-add-friend-block');
    var clearFriendBlock = document.querySelector('.js-select-clear-share');
    var sendShareBtn = document.querySelector('.js-send-share-btn');

    var startDate = document.querySelector('#js-select-start-favourites');
    var endDate = document.querySelector('#js-select-end-favourites');
    var pax = document.querySelector('#js-select-pax-favourites');

    archiveBtn.onclick = function () {
        archiveBtn.style.display = "none";
        confirmBtns.style.display = "block";
        confirmBtns.scrollIntoView();
    }

    cancelBtn.onclick = function () {
        confirmBtns.style.display = "none";
        archiveBtn.style.display = "block";
    }

    addFriendBtn.onclick = function () {
        addFriendBlock.style.display = "block";
        sendShareBtn.style.display = "block";
        addFriendBtn.style.display = "none";
    }
    clearFriendBlock.onclick = function () {
        addFriendBlock.style.display = "none";
        sendShareBtn.style.display = "none";
        addFriendBtn.style.display = "block";
        document.getElementById("js-friend-name").value = "";
        document.getElementById("js-friend-email").value = "";
    }

    deleteBtn.onclick = function () {
        favouritesUpdate('delete');
    }

    sendShareBtn.onclick = function () {
        favouritesUpdate('share');
    }

    // Prompt dates after change of pax
    pax.onchange = function () {

        // if both dates are empty on pax=2 don't prompt
        if (!startDate.value && !endDate.value && pax.value == 2) {
            return
        }

        if (!startDate.value) {
            const event = new CustomEvent('showFavouritesStartPicker');
            window.dispatchEvent(event);
        } else if (!endDate.value) {
            const event = new CustomEvent('showFavouritesEndPicker');
            window.dispatchEvent(event);
        }
    }

    // Prompt end date after start date
    startDate.onchange = function () {
        if (!endDate.value) {
            const event = new CustomEvent('showFavouritesEndPicker');
            window.dispatchEvent(event);
        }
    }

    // Prompt empty datepickers on submit
    updateBtn.onclick = function () {

        // if both dates are empty on pax=2 don't prompt
        if (!startDate.value && !endDate.value && pax.value == 2) {
            favouritesUpdate();
            return
        }

        if (!startDate.value) {
            const event = new CustomEvent('showFavouritesStartPicker');
            window.dispatchEvent(event);
        } else if (!endDate.value) {
            const event = new CustomEvent('showFavouritesEndPicker');
            window.dispatchEvent(event);
        } else {
            favouritesUpdate();
        }
    }

    // Dispatch an event to trigger rebind of pikaday in favourites-settings.js
    const event = new CustomEvent('rebindFavouritesSettings');
    window.dispatchEvent(event);
}


